module.exports = __webpack_public_path__ + "img/project-1.8853b10a.jpg";